import React, { Component } from "react";
import { http, baseURL } from "../misc/http";
import { getStatus2 } from "../misc/misc";
import Layout from "../layout/Main";
import allBackground from "../assets/kominfo-team-10.png";
import infographicBackground from "../assets/kominfo-team-8.png";
import blogBackground from "../assets/kominfo-team-9.png";
import galleryBackground from "../assets/video-kamera.png";
import Navigation from "../components/Event/Navigation";
import AllEvent from "../components/Event/AllEvent";
import Organizer from "../components/Event/Organizer";
import InfoGraphic from "../components/Event/InfoGraphic";
import ListVideoNGallery from "../components/Event/ListVideoNGallery";
import BlogArticle from "../components/Event/BlogArticle";
import { withRouter } from "react-router";

class Event extends Component {
  state = {
    path: "",
    background: "",
    title: "",
    listGallery: [],
    listOrganizer: [],
    listInfoGraphic: [],
    listEvent: [],
    pastEvent: [],
    comingEvent: [],
    tabs: "coming",
    loadedEvent: false,
    eventType: "",
  };

  componentDidMount = () => {
    this.initial();
  };

  initial = async () => {
    const { id } = this.props.match.params;
    await this.handleOnclick(id);
    await this.handleGetAll("gallery?status=publish", "listGallery");
    // await this.handleGetAll("organizer?limit=6", "listOrganizer");
    // await this.handleGetAll("infographic?status=publish", "listInfoGraphic");
    await this.getListEvent();
  };

  changeCategory = ({ target: { value } }) => {
    console.log(value);
    this.setState(
      {
        eventType: value,
      },
      this.getListEvent
    );
  };

  getListEvent = async () => {
    const { eventType } = this.state;
    this.setState({ loadedEvent: false });
    let params = {
      method: "GET",
      path: `events${eventType ? `?eventType=${eventType}` : ""}`,
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      let stateData = this.state.listEvent;
      let coming = [],
        past = [];
      stateData = data.data;
      stateData.forEach(async (item) => {
        const status = await getStatus2(item.endDate);
        if (status === 1) {
          coming.push(item);
        } else {
          past.push(item);
        }
      });
      this.setState({
        listEvent: stateData,
        pastEvent: past,
        comingEvent: coming,
        loadedEvent: true,
      });
      // this.setState({ listEvent: stateData });
    }
  };

  handleGetAll = async (path, stateName) => {
    let params = {
      method: "GET",
      path: path,
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      let stateData = this.state[stateName];
      stateData = data.data;
      this.setState({ [stateName]: stateData });
    }
  };

  handleOnclick = (path) => {
    let background = "";
    let title = "";
    if (path === "all") {
      background = allBackground;
      title = "Kegiatan Acara";
    }
    if (path === "infographic") {
      background = infographicBackground;
      title = "Infografik";
    }
    if (path === "organizer") {
      background = allBackground;
      title = "Penyelenggara";
    }
    if (path === "gallery") {
      background = galleryBackground;
      title = "Kumpulan Video & Gallery";
    }
    if (path === "blog") {
      background = blogBackground;
      title = "Blog Artikel";
    }
    this.setState({ path, background, title });
  };

  componentWillMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      this.handleOnclick(location.pathname.split("/")[2]);
    });
  }
  
  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    // console.log("checking load event ", this.state.loadedEvent);
    return (
      <Layout>
        <section className="header-apa-psre position-relative w-100">
          <img
            src={this.state.background}
            alt="kominfo-team"
            style={{ width: "100%", height: "auto" }}
          />
          <div
            className="position-absolute d-lg-block d-none"
            style={{ top: "50%", left: "10%", transform: "translate(0, -50%)" }}
          >
            <p
              style={{ fontSize: "3.2rem", fontWeight: "600", color: "white" }}
            >
              {this.state.title}
            </p>
          </div>
        </section>
        <Navigation path={this.state.path} handleOnclick={this.handleOnclick} />
        <div style={{ minHeight: 300 }}>
          {this.state.path == "all" ? (
            <AllEvent
              pastEvent={this.state.pastEvent}
              comingEvent={this.state.comingEvent}
              listEvent={this.state.listEvent}
              baseURL={baseURL}
              changeCategory={this.changeCategory}
              eventType={this.state.eventType}
            />
          ) : null}
          {this.state.path == "organizer" ? (
            <Organizer
              listOrganizer={this.state.listOrganizer}
              baseURL={baseURL}
            />
          ) : null}
          {this.state.path == "infographic" ? (
            <InfoGraphic
              listInfoGraphic={this.state.listInfoGraphic}
              baseURL={baseURL}
            />
          ) : null}
          {this.state.path == "gallery" ? (
            <ListVideoNGallery
              listGallery={this.state.listGallery}
              baseURL={baseURL}
            />
          ) : null}
          {this.state.path == "blog" ? <BlogArticle /> : null}
        </div>
      </Layout>
    );
  }
}

export default withRouter(Event);
